<sp-admin-export-map-import
    *ngIf="propertyId"
    [propertyId]="propertyId"
    (uploading)="onUploading()"
    (uploaded)="onUploaded($event)">
</sp-admin-export-map-import>
<section>
    <header class="row page-header">
        <div class="col-sm-12">

            <sp-breadcrumbs>
                <sp-breadcrumb [text]="'Admin'" [routerLink]="'../../../'"></sp-breadcrumb>
                <sp-breadcrumb [text]="'Properties'" [routerLink]="'../../'"></sp-breadcrumb>
                <sp-breadcrumb [text]="(property$ | async)?.name" [routerLink]="'../'"></sp-breadcrumb>
            </sp-breadcrumbs>

            <div class="row">
                <div class="col-sm-4">
                    <a class="btn-back" [routerLink]="['../']"></a>
                    <h2 class="title">Export Map</h2>
                </div>
                <div class="col-sm-8 text-end">
                    <div class="controls">
                        <button class="btn btn-link" (click)="onExport()" *ngIf="!(exportMap$ | async)">
                            <i class="fa fa-plus" aria-hidden="true"></i> Generate New Export Map
                        </button>

                        <button class="btn btn-link" (click)="onExport()" *ngIf="(exportMap$ | async)">
                            <i class="fa fa-download" aria-hidden="true"></i> Download Export Map
                        </button>

                        <button class="btn btn-link" (click)="importComponent.show()">
                            <i class="fa fa-cloud-upload" aria-hidden="true"></i> Import Export Map
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </header>

    <div class="row">
        <div class="col-sm-12 comm-state">
            <div style="margin:10px auto;">
                <sp-comm-state [successMessage]="'Export Map imported successfully'" [failedMessage]="'Export Map import failed'" #uploadState></sp-comm-state>
            </div>
        </div>
    </div>

    <main>
        <sp-admin-property-export-map-details
            *ngIf="property$ | async"
            [exportMap]="exportMap$ | async"
            [property]="property$ | async"
            (export)="onExport()">
        </sp-admin-property-export-map-details>
    </main>
</section>
